import {
  type WorkspaceAgentAssetLikePill,
  type WorkspaceAgentMessagePill,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';

/** Positive check on purpose: the negative would sweep up comment and changePreview pills. */
export const isWorkspaceAgentAssetPill = (pill: WorkspaceAgentMessagePill): pill is WorkspaceAgentAssetLikePill =>
  pill.type === 'asset' || pill.type === 'assetList';
